import { render, staticRenderFns } from "./NotificationSettingDetail.vue?vue&type=template&id=a3121482&"
import script from "./NotificationSettingDetail.vue?vue&type=script&lang=ts&"
export * from "./NotificationSettingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports